import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import HowItWorks from './components/HowItWorks';
import './App.css';
import image from "./img/btc-world-logo.webp";

function App() {
  return (
    <Router>
      <div className="App" style={{backgroundImage:`url(${image})`, backgroundRepeat:"no-repeat",backgroundSize:"contain", backgroundPosition: "center", height: '100vh'}}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<HowItWorks />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;